import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Image = forwardRef(function Image(
    { testid = 'image', className = '', icon = '', ...rest },
    ref
) {
    return (
        <svg data-testid={testid} ref={ref} className={`size-6 ${className}`} {...rest}>
            <use href={`/assets/images/svg/new-icons/${icon}.svg#${icon}`} />
        </svg>
    );
});

Image.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
};

export default Image;
